<template>
  <Banner
    :image="image"
    :ariaLabel="ariaLabel"
    :minHeight="minHeight"
  >
    <div class="container pagetitle">
      <div class="row align-items-center">
        <div class="col-auto">
          <img class="corridaecaminhada" :src="CorridaECaminhadaImage" alt="3ª Corrida e Caminhada - Cidade de Deus">
        </div>
        <div class="col-12 col-lg">
          <div :class="{ 'title-fix': text }">
            <h1>{{ title }}</h1>
            <p v-if="text">{{ text }}</p>
          </div>
        </div>
      </div>
    </div>
    <BradescoLine/>
  </Banner>
</template>

<script>
import BradescoLine from '@/components/BradescoLine'
import Banner from '@/components/Banner'
import CorridaECaminhadaImage from '@/images/3-corrida-e-caminhada-cidade-de-deus.png'

export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      required: true
    },
    ariaLabel: {
      type: String,
      default: ""
    },
    text: String,
    minHeight: {
      type: Number,
      default: 420
    },
  },
  components: {
    Banner,
    BradescoLine,
  },
  data: () => ({
    CorridaECaminhadaImage,
  })
}
</script>

<style lang="scss" scoped>
.pagetitle {
  margin-top: 60px;
  margin-bottom: 50px;
}
.corridaecaminhada {
  width: 160px;
}
h1,
p {
  color: #fff;
}
h1 {
  font-size: 70px;
  font-weight: 600;
  @media (max-width: 767px) {
    font-size: 40px;
  }
}
p {
  font-size: 18px;
  margin-top: 17px;
}
.title-fix {
  margin-top: 18px;
}
</style>
